import React from 'react';
import { Fieldset } from '~/components/FormControl';
import { Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import CheckboxGroup from '~/components/CheckboxGroup';

function ActiveRounds({ smCol, smCheckbox }) {
    const roundLists = [
        { id: 1, name: 'Round 1' },
        { id: 2, name: 'Round 2' },
        { id: 3, name: 'Round 3' },
    ];

    return (
        <Col
            sm={smCol}
            className={'d-flex'}
        >
            <Fieldset
                className={'px-4'}
                fieldsetStyle={{ flexGrow: 1 }}
            >
                <Fieldset.Legend>Active Rounds:</Fieldset.Legend>
                <CheckboxGroup
                    options={roundLists}
                    fieldName="activeRounds"
                    sm={smCheckbox}
                />
            </Fieldset>
        </Col>
    );
}

ActiveRounds.defaultProps = {
    smCol: 6,
    smCheckbox: 3,
};

ActiveRounds.propTypes = {
    smCol: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    smCheckbox: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default ActiveRounds;
